document.addEventListener('DOMContentLoaded', function () {
    if (!location.href.includes('a/statut-livraison')) return;

    // =========================================================
    // CONFIG WORKER (À REMPLACER)
    // =========================================================
    const WORKER_URL = 'https://parcelwill-location-bridge.contact-bange.workers.dev';
    const WORKER_KEY = 'Bange_Parcel_Bridge_2026_3FFF_T9uxe43VGc32N2A';

    // Cache runtime bridge Shopify -> ParcelWILL
    let pwLocationBridgeState = {
        loading: false,
        loaded: false,
        error: null,
        orderNumber: null,
        workerJson: null,
        trackingMap: new Map() // trackingNumber -> { locationName, confidence, method, raw }
    };

    // === Partie 1 : duplication du numéro de suivi (inchangée + ensure button) ===
    var checked = false;
    var trackingNumberInfo = extractTrackingNumber();
    if (trackingNumberInfo) {
        duplicateTrackingNumber(trackingNumberInfo);
        checked = true;
    }
    if (!checked) {
        var intervalId = setInterval(function () {
            var trackingNumberInfo = extractTrackingNumber();
            if (trackingNumberInfo) {
                duplicateTrackingNumber(trackingNumberInfo);
                clearInterval(intervalId);
            }
        }, 1000);
    }

    function extractTrackingNumber() {
        var trackingInfoElement = document.querySelector('#pp-tracking-page-app > div > div.pp_tracking_result > div.pp_tracking_right > ul > li.PP-SectionItem.PP-Section-CarrierInfo');
        if (trackingInfoElement) {
            var text = trackingInfoElement.textContent || trackingInfoElement.innerText;
            var matchColissimo = text.match(/6A\d{11}/);
            var matchColisPrive = text.match(/Q10\w+/);
            var matchDPD = text.match(/06\d{12}/);

            if (matchColissimo) return { type: 'Colissimo', number: matchColissimo[0] };
            if (matchColisPrive) return { type: 'Colis Privé', number: matchColisPrive[0] };
            if (matchDPD) return { type: 'DPD', number: matchDPD[0] };
        }
        return null;
    }

    function duplicateTrackingNumber(trackingNumberInfo) {
        var firstInsertLocation = document.getElementById('duplicatedTrackingNumberContainer');
        if (firstInsertLocation) {
            var link = document.createElement('a');
            var url;

            if (trackingNumberInfo.type === 'Colissimo') {
                url = 'https://www.laposte.fr/outils/suivre-vos-envois?code=' + trackingNumberInfo.number;
            } else if (trackingNumberInfo.type === 'Colis Privé') {
                url = 'https://colisprive.com/moncolis/pages/detailColis.aspx?numColis=' + trackingNumberInfo.number;
            } else if (trackingNumberInfo.type === 'DPD') {
                url = 'https://www.dpdgroup.com/nl/mydpd/my-parcels/incoming?parcelNumber=' + trackingNumberInfo.number;
            }

            link.href = url;
            link.textContent = 'Cliquez ici pour suivre sur le site de ' + trackingNumberInfo.type;
            link.target = '_blank';

            firstInsertLocation.innerHTML = '';
            firstInsertLocation.appendChild(link);
        }

        var secondInsertLocation = document.getElementById('secondTrackingNumberContainer');
        if (secondInsertLocation) {
            secondInsertLocation.textContent = 'Numéro de suivi: ' + trackingNumberInfo.number;
        }

        // Tente aussi d'appliquer la logique du bouton externe dès qu'on a un tracking
        ensureExternalColissimoButton();
    }

    // === Utils ===
    function normalize(str) {
        return (str || '').replace(/\u00A0/g, ' ').replace(/\s+/g, ' ').trim();
    }

    function findTrackingTextRoot() {
        return document.querySelector('.pp_tracking_left') ||
               document.querySelector('.pp_tracking_result') ||
               document.body;
    }

    // 🔧 Nouveau : récupérer le texte en ignorant .pp_num_status_show
    function getTextWithoutStatus(rootEl) {
        if (!rootEl) return '';
        const clone = rootEl.cloneNode(true);
        const statusNodes = clone.querySelectorAll('.pp_num_status_show');
        statusNodes.forEach(n => n.remove());
        return normalize(clone.textContent || '');
    }

    // Forçage du statut principal (sélecteurs robustes)
    function setMainStatus(text) {
        const selectors = [
            'h1.pp_num_status_show.h1.u-h1',
            'h1.pp_num_status_show.u-h1',
            'h1.pp_num_status_show',
            '.pp_num_status_show h1',
            '.pp_num_status h1',
            '.pp_num_status_show .u-h1',
            '.pp_tracking_result h1.u-h1',
            '.pp_tracking_result h1'
        ];
        for (const sel of selectors) {
            const el = document.querySelector(sel);
            if (el) { el.textContent = text; return true; }
        }
        const root = document.querySelector('.pp_tracking_result') || document;
        const heads = root.querySelectorAll('h1, .u-h1');
        for (const h of heads) {
            const t = normalize(h.textContent).toLowerCase();
            if (['commandé','commande prête','en transit','en cours de livraison','livré'].includes(t)) {
                h.textContent = text;
                return true;
            }
        }
        return false;
    }

    // Applique le lock "Commande prête" (avec !important)
    function enforceLockCommandePrete() {
        // Desktop
        const desktopProgressBar = document.querySelector('.progress-bar-style');
        if (desktopProgressBar && desktopProgressBar.style && desktopProgressBar.style.setProperty) {
            desktopProgressBar.style.setProperty('--bar-percent', '25%', 'important');
            desktopProgressBar.style.setProperty('--bar-percent-mobile', '30%', 'important');
        }
        const desktopNodes = document.querySelectorAll('.progress-bar-node');
        desktopNodes.forEach((node, index) => {
            if (index > 1) {
                node.classList.remove('progress-bar-node--active');
                node.classList.add('progress-bar-node-disabled');
            } else {
                node.classList.add('progress-bar-node--active');
                node.classList.remove('progress-bar-node-disabled');
            }
        });

        // Mobile
        const mobileProgressBar = document.querySelector('.progress-bar-mobile-style');
        if (mobileProgressBar && mobileProgressBar.style && mobileProgressBar.style.setProperty) {
            mobileProgressBar.style.setProperty('--bar-percent', '30%', 'important');
            mobileProgressBar.style.setProperty('--bar-percent-mobile', '30%', 'important');
        }
        const mobileSteps = document.querySelectorAll('.progress-bar-mobile-style .progress-bar-mobile-list');
        mobileSteps.forEach((step, index) => {
            if (index > 1) {
                step.classList.remove('progress-bar-mobile-node--active');
                step.classList.add('progress-bar-mobile-disabled');
            } else {
                step.classList.add('progress-bar-mobile-node--active');
                step.classList.remove('progress-bar-mobile-disabled');
            }
        });

        // Statut principal
        setMainStatus('Statut: Commande prête');
    }

    // =========================================================
    // Bridge Shopify -> Worker (emplacement par tracking)
    // =========================================================
    function extractOrderNumberFromPage() {
        const titleEl = document.querySelector('.pp_tracking_result_title.h1.u-h1');
        if (titleEl) {
            const txt = normalize(titleEl.textContent || '');
            const m = txt.match(/\bBG\d{5,}\b/i);
            if (m) return m[0].toUpperCase();
        }

        const root = document.querySelector('#pp-tracking-page-app') || document.body;
        const txt = normalize(root.textContent || '');
        const m = txt.match(/\bBG\d{5,}\b/i);
        return m ? m[0].toUpperCase() : null;
    }

    async function fetchShopifyLocationBridge(orderNumber) {
        const url = `${WORKER_URL}/?order=${encodeURIComponent(orderNumber)}&key=${encodeURIComponent(WORKER_KEY)}`;
        const res = await fetch(url, { method: 'GET' });
        const data = await res.json();
        if (!res.ok) {
            throw new Error(data?.error ? `${data.error} | ${JSON.stringify(data)}` : `HTTP ${res.status}`);
        }
        return data;
    }

    function buildTrackingLocationMapFromWorker(workerJson) {
        const map = new Map();
        const rows = workerJson?.naiveTrackingLocationMap || [];
        rows.forEach(r => {
            if (r && r.trackingNumber) {
                map.set(String(r.trackingNumber).trim(), {
                    locationName: r.locationName || null,
                    confidence: r.confidence || null,
                    method: r.method || null,
                    raw: r
                });
            }
        });
        return map;
    }

    async function ensureWorkerLocationBridgeLoaded() {
        if (pwLocationBridgeState.loaded || pwLocationBridgeState.loading) return;
        const orderNumber = extractOrderNumberFromPage();
        if (!orderNumber) return;

        pwLocationBridgeState.loading = true;
        pwLocationBridgeState.orderNumber = orderNumber;
        pwLocationBridgeState.error = null;

        try {
            const workerJson = await fetchShopifyLocationBridge(orderNumber);
            pwLocationBridgeState.workerJson = workerJson;
            pwLocationBridgeState.trackingMap = buildTrackingLocationMapFromWorker(workerJson);
            pwLocationBridgeState.loaded = true;
        } catch (e) {
            pwLocationBridgeState.error = e;
            console.error('[pw-location-bridge]', e);
        } finally {
            pwLocationBridgeState.loading = false;
        }
    }

    function getLocationForTracking(trackingNumber) {
        if (!trackingNumber) return null;
        if (!pwLocationBridgeState.trackingMap) return null;
        return pwLocationBridgeState.trackingMap.get(String(trackingNumber).trim()) || null;
    }

    // === Nouvelle fonction : masque + bouton Colissimo si tracking + emplacement MFP ECOM ===
    const externalColissimoBtnId = 'pw-external-colissimo-cta-wrap';

    function hideElWithMemory(el) {
        if (!el) return;
        if (el.dataset.pwExternalHidden !== '1') {
            el.dataset.pwExternalHidden = '1';
            el.dataset.pwExternalPrevDisplay = el.style.display || '';
        }
        el.style.setProperty('display', 'none', 'important');
    }

    function restoreElWithMemory(el) {
        if (!el) return;
        if (el.dataset.pwExternalHidden === '1') {
            const prev = el.dataset.pwExternalPrevDisplay || '';
            if (prev) {
                el.style.display = prev;
            } else {
                el.style.removeProperty('display');
            }
            delete el.dataset.pwExternalHidden;
            delete el.dataset.pwExternalPrevDisplay;
        }
    }

    function removeExternalColissimoButton() {
        const existing = document.getElementById(externalColissimoBtnId);
        if (existing) existing.remove();
    }

    function getColissimoTrackingInfo() {
        const info = extractTrackingNumber();
        if (info && info.type === 'Colissimo' && info.number) return info;
        return null;
    }

    function ensureExternalColissimoButton() {
        const progressBarDesktop = document.querySelector('.progress-bar-style');
        const progressBarMobile = document.querySelector('.progress-bar-mobile-style');
        const trackingLeftBlock = document.querySelector('.pp_tracking_left');

        // Condition A : on a un tracking Colissimo
        const colissimoInfo = getColissimoTrackingInfo();

        // Condition B : le worker a mappé ce tracking sur MFP ECOM
        let isMfpEcom = false;
        let locationRow = null;

        if (colissimoInfo && colissimoInfo.number) {
            locationRow = getLocationForTracking(colissimoInfo.number);
            isMfpEcom = !!(locationRow && locationRow.locationName === 'MFP ECOM');
        }

        // Nouvelle condition finale :
        // SI envoi a un numéro de suivi + emplacement = MFP ECOM
        const shouldSwitchToExternalCTA = !!(colissimoInfo && isMfpEcom);

        // Si les conditions ne sont pas réunies, on restaure l'affichage normal
        if (!shouldSwitchToExternalCTA) {
            restoreElWithMemory(progressBarDesktop);
            restoreElWithMemory(progressBarMobile);
            restoreElWithMemory(trackingLeftBlock);
            removeExternalColissimoButton();
            return;
        }

        // Action : masquer les blocs demandés
        hideElWithMemory(progressBarDesktop);
        hideElWithMemory(progressBarMobile);
        hideElWithMemory(trackingLeftBlock);

        // URL Colissimo
        const colissimoUrl = 'https://www.laposte.fr/outils/suivre-vos-envois?code=' + colissimoInfo.number;

        // Point d'injection : juste après le bloc des statuts si possible
        const parent = (trackingLeftBlock && trackingLeftBlock.parentNode) ||
                       document.querySelector('.pp_tracking_result') ||
                       document.body;

        if (!parent) return;

        let wrapper = document.getElementById(externalColissimoBtnId);
        if (!wrapper) {
            wrapper = document.createElement('div');
            wrapper.id = externalColissimoBtnId;
            wrapper.style.marginTop = '12px';

            if (trackingLeftBlock && trackingLeftBlock.parentNode) {
                trackingLeftBlock.insertAdjacentElement('afterend', wrapper);
            } else {
                parent.appendChild(wrapper);
            }
        }

        // ✅ Anti-clignotement / anti-récréation :
        // on réutilise le bouton existant si présent
        let btn = wrapper.querySelector('a[data-pw-external-colissimo-btn="1"]');

        if (!btn) {
            btn = document.createElement('a');
            btn.setAttribute('data-pw-external-colissimo-btn', '1');
            btn.target = '_blank';
            btn.rel = 'noopener noreferrer';
            btn.textContent = 'Suivi disponible sur Colissimo →';

            // ✅ Apparence / disposition conservées
            btn.style.cssText = [
                'display:block',
                'text-align:center',
                'text-decoration:none',
                'background:#ffc906',
                'color:#000000',
                'font-weight:500',
                'border:solid 1px #ffc906',
                'border-radius:5px',
                'padding:20px',
                'margin-bottom:50px'
            ].join(';');

            wrapper.appendChild(btn);
        }

        // Met à jour seulement si nécessaire
        if (btn.href !== colissimoUrl) {
            btn.href = colissimoUrl;
        }
    }

    // === Partie 2 : logique avec lock persistant ===
    const phraseRef1 = "Mise à jour du suivi : le colis est en route, avance conformément au planning prévu.";
    const phraseRef2 = "Colis Expédié : Votre colis est entre les mains de notre transporteur privé. Il est actuellement en transit vers les entrepôts de Colissimo - Rappel : Le délai de livraison moyen est de 5 à 7 jours ouvrés.";
    const phraseRef3 = "Colis Expédié : Votre colis est entre les mains de notre transporteur privé. Il est actuellement en transit vers les entrepôts du transporteur local - Rappel : Le délai de livraison moyen est de 5 à 7 jours ouvrés.";
    const phrasePreparation = "Votre commande est actuellement en cours de préparation pour l'expédition. Nous mettons tout en œuvre pour qu'elle soit prête à partir le plus rapidement possible. Merci de votre confiance !";

    let lockActive = false;     // si true, on réimpose le lock à chaque mutation
    let scheduled = false;

    function shouldLock() {
        const root = findTrackingTextRoot();
        const text = getTextWithoutStatus(root); // 🔥 texte SANS .pp_num_status_show

        // Priorité aux phrases de référence : si présentes -> pas de lock
        if (text.includes(normalize(phraseRef1)) || text.includes(normalize(phraseRef2)) || text.includes(normalize(phraseRef3))) return false;
        // Si phrase de préparation -> pas de lock
        if (text.includes(normalize(phrasePreparation))) return false;

        // 👉 Règle "En transit" uniquement dans .pp_tracking_left, SANS .pp_num_status_show
        const left = document.querySelector('.pp_tracking_left');
        if (left) {
            const leftText = getTextWithoutStatus(left); // SANS .pp_num_status_show
            if (leftText.includes('En transit')) {
                return false;
            }
        }

        // Sinon -> lock
        return true;
    }

    function tick() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(async () => {
                try {
                    // 1) Tente de charger le mapping Shopify -> emplacement
                    await ensureWorkerLocationBridgeLoaded();

                    // 2) Logique lock existante
                    const needLock = shouldLock();
                    if (needLock) {
                        lockActive = true;
                        enforceLockCommandePrete();
                    } else {
                        lockActive = false; // on laisse ParcelPanel dérouler normalement
                    }

                    // Si le lock est actif, on réimpose à chaque cycle (ParcelPanel peut réécrire)
                    if (lockActive) enforceLockCommandePrete();

                    // 3) Nouvelle logique CTA Colissimo basée sur emplacement MFP ECOM
                    ensureExternalColissimoButton();

                } catch (e) {
                    console.error('[tracking lock] ', e);
                } finally {
                    scheduled = false;
                }
            }, 250); // throttle
        }
    }

    // Observe tout le body (ParcelPanel reconstruit souvent profondément)
    const observer = new MutationObserver(() => {
        tick();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Démarrage + filet de sécurité périodique (faible coût)
    tick();
    const keepAlive = setInterval(() => {
        tick();
        // Optionnel : après 20s, on peut arrêter si pas de lock et pas d’update nécessaire
        // clearInterval(keepAlive);
    }, 1000);
});